/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VacancyKpiReportControllerGetVacanciesReport200ResponseDataVacanciesSummaryVacanciesInner { 
    area?: string;
    position?: string;
    salary?: number;
    type?: string;
    typeColor?: string;
    days?: number;
    status?: string;
    statusColor?: string;
    startDate?: string | null;
}

